import { Phone } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[100] w-14 h-14 rounded-full flex items-center justify-center wa-pulse"
      style={{ background: "#25D366", color: "white", boxShadow: "0 10px 30px -6px rgba(37,211,102,0.5)" }}
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.35c-.29-.15-1.7-.84-1.96-.94-.26-.1-.45-.14-.65.14-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.14-1.21-.44-2.31-1.42-.85-.76-1.43-1.7-1.6-1.99-.17-.29-.02-.44.13-.59.13-.13.29-.34.44-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.14-.65-1.56-.89-2.13-.23-.56-.47-.48-.65-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 .97-1 2.37 0 1.4 1.02 2.75 1.16 2.94.14.19 2 3.05 4.85 4.28.68.29 1.21.47 1.62.6.68.22 1.3.19 1.79.11.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34zM16.02 4c-6.63 0-12 5.37-12 12 0 2.12.55 4.11 1.53 5.85L4 28l6.32-1.65A11.94 11.94 0 0 0 16.02 28c6.63 0 12-5.37 12-12s-5.37-12-12-12zm0 21.83a9.83 9.83 0 0 1-5-1.37l-.36-.21-3.75.98 1-3.65-.24-.38A9.83 9.83 0 1 1 16.02 25.83z" />
      </svg>
    </a>
  );
}

export function CallFab() {
  return (
    <a
      data-testid="call-fab"
      href="tel:+14375571041"
      className="fixed bottom-6 left-6 z-[100] w-12 h-12 rounded-full items-center justify-center hidden md:flex"
      style={{ background: "var(--primary)", color: "white", boxShadow: "0 10px 30px -6px rgba(31,74,44,0.45)" }}
      aria-label="Call now"
    >
      <Phone size={20} />
    </a>
  );
}
